// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estilos de paginación en pantalla grande */
@media (min-width: 768px) {
  .pagination-controls {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    margin-top: 1rem;
  }
}

/* Mantener centrado en mobile */
@media (max-width: 767px) {
  .pagination-controls {
    display: flex;
    justify-content: center;
    gap: 0.5rem;
    width: 100%;
  }
}

/* Estilos para centrar los controles de paginación */
.pagination-controls {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  margin: 1rem auto;
  padding: 0.5rem;
  width: 100%;
}

/* Estilo para los botones de paginación */
.btn-page {
  padding: 8px 14px;
  border: 1px solid #d48402;
  background-color: transparent;
  color: #d48402;
  border-radius: 20px;
  cursor: pointer;
  transition:
    background-color 0.3s,
    color 0.3s,
    border-color 0.3s;
  font-size: 14px;
}

.btn-page:hover:not(.active) {
  background-color: rgba(212, 132, 2, 0.2);
  color: #d48402;
}

.btn-page.active {
  background-color: #d48402;
  color: #fff;
  font-weight: bold;
  border-color: #d48402;
}

.pagination-controls .btn-prev,
.pagination-controls .btn-next {
  all: unset !important;
  background-color: #ff8c00 !important;
  color: #ffffff !important;
  /* border: 2px solid #ffffff !important; */
  border-radius: 8px !important;
  padding: 0.5rem !important;
  font-size: 1rem !important;
  font-weight: bold !important;
  cursor: pointer !important;
  transition:
    background-color 0.3s,
    transform 0.2s !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-sizing: border-box !important;
}

.pagination-controls .btn-prev:hover:not([disabled]),
.pagination-controls .btn-next:hover:not([disabled]) {
  background-color: #e57a00;
  transform: scale(1.05);
}

.pagination-controls .btn-prev[disabled],
.pagination-controls .btn-next[disabled] {
  opacity: 0.25 !important;
  cursor: not-allowed !important;
}

.pagination-controls .btn-prev i.bi,
.pagination-controls .btn-next i.bi {
  font-size: 1rem !important;
  line-height: 1 !important;
  display: inline-block !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/UI/pagination/pagination.component.css"],"names":[],"mappings":"AAAA,6CAA6C;AAC7C;EACE;IACE,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA,gCAAgC;AAChC;EACE;IACE,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,WAAW;EACb;AACF;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA,0CAA0C;AAC1C;EACE,iBAAiB;EACjB,yBAAyB;EACzB,6BAA6B;EAC7B,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf;;;qBAGmB;EACnB,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;EACrB,oCAAoC;EACpC,yBAAyB;EACzB,0CAA0C;EAC1C,6BAA6B;EAC7B,0BAA0B;EAC1B,0BAA0B;EAC1B,4BAA4B;EAC5B,0BAA0B;EAC1B;;6BAE2B;EAC3B,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;;EAEE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;;EAEE,0BAA0B;EAC1B,yBAAyB;EACzB,gCAAgC;AAClC","sourcesContent":["/* Estilos de paginación en pantalla grande */\n@media (min-width: 768px) {\n  .pagination-controls {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 0.5rem;\n    margin-top: 1rem;\n  }\n}\n\n/* Mantener centrado en mobile */\n@media (max-width: 767px) {\n  .pagination-controls {\n    display: flex;\n    justify-content: center;\n    gap: 0.5rem;\n    width: 100%;\n  }\n}\n\n/* Estilos para centrar los controles de paginación */\n.pagination-controls {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 1rem auto;\n  padding: 0.5rem;\n  width: 100%;\n}\n\n/* Estilo para los botones de paginación */\n.btn-page {\n  padding: 8px 14px;\n  border: 1px solid #d48402;\n  background-color: transparent;\n  color: #d48402;\n  border-radius: 20px;\n  cursor: pointer;\n  transition:\n    background-color 0.3s,\n    color 0.3s,\n    border-color 0.3s;\n  font-size: 14px;\n}\n\n.btn-page:hover:not(.active) {\n  background-color: rgba(212, 132, 2, 0.2);\n  color: #d48402;\n}\n\n.btn-page.active {\n  background-color: #d48402;\n  color: #fff;\n  font-weight: bold;\n  border-color: #d48402;\n}\n\n.pagination-controls .btn-prev,\n.pagination-controls .btn-next {\n  all: unset !important;\n  background-color: #ff8c00 !important;\n  color: #ffffff !important;\n  /* border: 2px solid #ffffff !important; */\n  border-radius: 8px !important;\n  padding: 0.5rem !important;\n  font-size: 1rem !important;\n  font-weight: bold !important;\n  cursor: pointer !important;\n  transition:\n    background-color 0.3s,\n    transform 0.2s !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  box-sizing: border-box !important;\n}\n\n.pagination-controls .btn-prev:hover:not([disabled]),\n.pagination-controls .btn-next:hover:not([disabled]) {\n  background-color: #e57a00;\n  transform: scale(1.05);\n}\n\n.pagination-controls .btn-prev[disabled],\n.pagination-controls .btn-next[disabled] {\n  opacity: 0.25 !important;\n  cursor: not-allowed !important;\n}\n\n.pagination-controls .btn-prev i.bi,\n.pagination-controls .btn-next i.bi {\n  font-size: 1rem !important;\n  line-height: 1 !important;\n  display: inline-block !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
